(function () {
  if (/\/pages\/contact(?:$|[?#/])/.test(window.location.pathname + window.location.search)) {
    const cleanContactPhone = () => {
      const rows = document.querySelectorAll('.liora-contact-page-copy p, [data-liora-phone-row], main p');
      for (const row of rows) {
        const text = row.textContent || '';
        if (!/\bPhone\b/i.test(text) && !row.querySelector('a[href^="tel:"]')) continue;
        if (!/175\s*0760\s*1417|17507601417|\+86\+86/i.test(text + ' ' + (row.innerHTML || ''))) continue;
        if (!row.querySelector('a[href^="tel:"]') && !/17507601417|\+86\+86/i.test(text) && /\+86 175 0760 1417/.test(text)) continue;

        row.innerHTML =
          '<strong>Phone:</strong> ' +
          '<span class="notranslate" translate="no">+86 175 0760 1417</span>';
      }

      for (const link of document.querySelectorAll('a[href^="tel:"]')) {
        const value = `${link.getAttribute('href') || ''} ${link.textContent || ''}`;
        if (/175\s*0760\s*1417|17507601417|\+86\+86/i.test(value)) {
          link.outerHTML = '<span class="notranslate" translate="no">+86 175 0760 1417</span>';
        }
      }
    };

    cleanContactPhone();
    document.addEventListener('DOMContentLoaded', cleanContactPhone, { once: true });
    window.addEventListener('load', cleanContactPhone, { once: true });

    const startContactPhoneObserver = () => {
      if (!document.body) return;
      const observer = new MutationObserver(cleanContactPhone);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'] });
      setTimeout(() => observer.disconnect(), 120000);
    };
    if (document.body) startContactPhoneObserver();
    else document.addEventListener('DOMContentLoaded', startContactPhoneObserver, { once: true });
  }

  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  // Remove the view transition render blocker if the user has reduced motion enabled or is on a low power device.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    viewTransitionRenderBlocker?.remove();
  } else {
    // If the browser didn't manage to parse the main content quickly, at least let the user see something.
    // We're aiming for the FCP to be under 1.8 seconds since the navigation started.
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());

    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * @param {ViewTransition | null} viewTransition
   * @returns {viewTransition is null}
   */
  function shouldSkipViewTransition(viewTransition) {
    return !(viewTransition instanceof ViewTransition) || isLowPowerDevice();
  }

  /*
   * We can't import this logic from utilities.js here, but we should keep them in sync.
   */
  function isLowPowerDevice() {
    /* Skip ESLint compatibility check. Number(undefined) <= 2 is always false anyway. */
    /* eslint-disable-next-line compat/compat */
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();
